class NfeDetails {
    constructor(scope, gql, api, UsuariosService, EfSocket) {
        this.gql = gql
        this.api = api
        this.UsuariosService = UsuariosService
        this.EfSocket = EfSocket
        this.apply = (fn) => scope.$apply(fn)
    }

    $onInit() {
        this.channel = `nfes:${this.contratoId}`
        this.loadingPromise = this.loadNfe()
    }

    getDescricaoEvento(evento) {
        switch (evento) {
            case 'CIENCIA':
                return 'Ciência da operação';
            case 'CONFIRMACAO':
                return 'Confirmação da operação';
            case 'NAO_REALIZADO':
                return 'Operação não Realizada';
            case 'DESCONHECIMENTO':
                return 'Desconhecimento da operação';
        }
    }

    informarTipoDestinacao(item, tipo = {}) {
        return this._socket()
            .push(this.channel, 'informar_tipo_destinacao', { item: item.id, tipo: tipo.id || null })
            .then(() => {
                Alert.success(`Tipo de destinação do item n° ${item.sequencia} informado com sucesso.`, 'Sucesso')
            })
            .catch(() => {
                throw "Erro ao informar tipo destinação"
            })
    }

    loadTiposDestinacao(sigla) {
        return this.api
            .get('/icms/tipo-destinacao', { estado_sigla: sigla })
            .then(({ data }) => {
                this.tiposDestinacao = [{ descricao: 'não informado -' }, ...data.items]
            })
    }

    loadNfe() {
        const query = gql`
            query NfeDetails($filialId: Int!, $filter: NfeFilter!) {
                filial(id: $filialId) {
                    id
                    cidade {
                        id
                        estado {
                            id
                            sigla
                        }
                    }
                    nfe(filter: $filter) {
                        id
                        numero
                        chave
                        emissao
                        valor
                        informacoesComplementares
                        emitente {
                            id
                            nome
                            cpfCnpj
                            municipio
                            uf
                        }
                        itens {
                            id
                            sequencia
                            descricao
                            codigoBarras
                            ncm
                            quantidade
                            tipoDestinacao {
                                id
                                codigo
                                descricao
                            }
                        }
                        eventos {
                            tipo
                            nome
                            data
                            eventoRfb { insertedAt }
                        }
                        manifestos {
                            evento
                            codigo
                            justificativa
                            retorno
                            vinculado
                            insertedAt
                            usuario { nome }
                        }
                    }
                }
            }
        `

        const variables = { filialId: parseInt(this.empresaId), filter: { ids: [this.nfe.toString()] } }

        return this.gql
            .query(query, variables)
            .then(({ filial: { cidade: { estado: { sigla } }, nfe } }) => {
                this.apply(() => this.nfe = nfe)

                return this.loadTiposDestinacao(sigla)
            })
            .catch(console.error)
    }

    _socket() {
        return this.EfSocket.socket(this.UsuariosService.token)
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeDetails', {
        controller: ['$scope', 'gql', 'api', 'UsuariosService', 'EfSocket', NfeDetails],
        bindings: {
            nfe: '<',
            contratoId: '<',
            empresaId: '<'
        },
        template: `
        <div auth="auth">
            <div ng-hide="true" class="widget-body-toolbar"></div>
            <div class="margin-menos-13">
                <div></div>
                <loading promise="$ctrl.loadingPromise">                    
                    <div ng-if="$ctrl.nfe" class="row">
                        <div class="col col-xs-12">
                            <div class="smart-form">
                                <div class="col-sm-6 col-xs-12">
                                    <cbk-well titulo="NF-e" icon="fa-file-text-o">
                                        <section class="col col-sm-4 col-xs-12"><label class="label">Número</label><label
                                                class="input"><span class="text-primary">{{$ctrl.nfe.numero}}</span></label>
                                        </section>
                                        <section class="col col-sm-4 col-xs-12"><label class="label">Data de
                                            emissão</label><label class="input"><span class="text-primary">{{$ctrl.nfe.emissao | date:'dd/MM/yyyy'}}</span></label>
                                        </section>
                                        <section class="col col-sm-4 col-xs-12"><label class="label">Valor</label><label
                                                class="input"><span class="text-primary">{{$ctrl.nfe.valor ? ($ctrl.nfe.valor | currency) : '-'}}</span></label>
                                        </section>
                                        <div class="clearfix">
                                            <section class="col col-sm-12 col-xs-12"><label class="label">Chave</label><label
                                                    class="input"><span class="text-primary">{{$ctrl.nfe.chave}}</span></label>
                                            </section>
                                            <section ng-if="$ctrl.nfe.key" class="col col-sm-12 col-xs-12"><label class="label">Download</label><label
                                                    class="input"><a target="_parent" href="/file/{{$ctrl.nfe.key}}"
                                                                     class="cursor-pointer">Clique aqui para baixar o arquivo XML</a></label></section>
                                        </div>
                                    </cbk-well>
                                </div>
                                <div class="col-sm-6 col-xs-12">
                                    <cbk-well titulo="Emitente" icon="fa-file-text-o">
                                        <section class="col col-sm-12 col-xs-12">
                                            <label class="label">Razão Social</label>
                                            <label class="input">
                                                <span class="text-primary">{{$ctrl.nfe.emitente.nome}}</span>
                                            </label>
                                        </section>
                                        <div class="clearfix">
                                            <section class="col col-sm-4 col-xs-12">
                                                <label class="label">CNPJ</label>
                                                <label class="input">
                                                    <span class="text-primary">{{$ctrl.nfe.emitente.cpfCnpj | cpfCnpj}}</span>
                                                </label>
                                            </section>
                                        </div>
                                        <div class="clearfix">
                                            <section class="col col-sm-6 col-xs-12">
                                                <label class="label">Município/Estado</label>
                                                <label class="input">
                                                    <span class="text-primary">
                                                        {{$ctrl.nfe.emitente.municipio ? $ctrl.nfe.emitente.municipio + '/': '-'}}
                                                        {{$ctrl.nfe.emitente.uf}}
                                                    </span>
                                                </label>
                                            </section>
                                        </div>
                                    </cbk-well>
                                </div>
                                <div ng-if="$ctrl.nfe.itens.length > 0" class="col-xs-12">
                                    <cbk-well titulo="Itens" icon="fa-file-text-o">
                                        <div class="clearfix">
                                            <table class="table table-hover table-striped">
                                                <thead>
                                                    <th width="1">Sequência</th>
                                                    <th>Descrição</th>
                                                    <th class="no-break">Tipo de destinação</th>
                                                    <th width="1" class="text-cenhter no-break">Código de barras</th>
                                                    <th width="1" class="text-center no-break">NCM</th>
                                                    <th width="1" class="text-center no-break">Quantidade</th>
                                                </thead>
                                                <tbody>
                                                    <tr ng-repeat="item in $ctrl.nfe.itens | orderBy:'sequencia.toInt()'">
                                                        <td>{{item.sequencia}}</td>
                                                        <td>{{item.descricao}}</td>
                                                        <td>
                                                            <a 
                                                            href="#" editable-select="item.tipoDestinacao" buttons="no" 
                                                            onbeforesave="$ctrl.informarTipoDestinacao(item, $data)"
                                                            tooltip="Editar tipo de destinação" tooltip-placement="top"
                                                            e-ng-options="tipoDestinacao as (tipoDestinacao.codigo + ' - ' + tipoDestinacao.descricao) 
                                                            for tipoDestinacao in $ctrl.tiposDestinacao track by tipoDestinacao.id"
                                                            e-style="width: 100%">
                                                            {{
                                                                item.tipoDestinacao 
                                                                ? (item.tipoDestinacao.codigo + ' - ' + item.tipoDestinacao.descricao) 
                                                                : '- não informado -'
                                                            }}
                                                            </a>
                                                        </td>
                                                        <td class="text-center">{{item.codigoBarras || '--'}}</td>
                                                        <td class="text-center">{{item.ncm}}</td>
                                                        <td class="text-center">{{item.quantidade}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </cbk-well>
                                </div>
                                <div ng-if="$ctrl.nfe.informacoesComplementares" class="col-xs-6">
                                    <cbk-well titulo="Informações complementares" icon="fa-file-text-o">
                                        <div class="clearfix">
                                            <section class="col col-xs-12">
                                                <p>{{ $ctrl.nfe.informacoesComplementares }}</p>
                                            </section>
                                        </div>
                                    </cbk-well>
                                </div>
                                <div ng-if="$ctrl.nfe.eventos.length > 0" class="{{$ctrl.nfe.informacoesComplementares ? 'col-xs-6' : 'col-xs-12'}}">
                                    <cbk-well titulo="Eventos da RFB" icon="fa-history">
                                        <div class="clearfix">
                                            <table class="table table-hover table-striped">
                                                <thead>
                                                    <th width="1">#</th>
                                                    <th>Tipo</th>
                                                    <th>Nome</th>
                                                    <th>Data</th>
                                                </thead>
                                                <tbody>
                                                    <tr ng-repeat="evento in $ctrl.nfe.eventos">
                                                        <td>{{ $index + 1 }}</td>
                                                        <td>{{ evento.tipo }}</td>
                                                        <td>{{ evento.nome }}</td>
                                                        <td>{{ evento.data | date:"dd/MM/yyyy HH:mm" }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </cbk-well>
                                </div>
                                <div ng-if="$ctrl.nfe.manifestos.length > 0" class="col-xs-12">
                                    <cbk-well titulo="Histórico" sub-titulo="manifesto destinatário" icon="fa-history">
                                        <div class="clearfix">
                                            <table class="table table-hover table-striped">
                                                <thead>
                                                    <th width="1">#</th>
                                                    <th>Evento</th>
                                                    <th>Retorno</th>
                                                    <th>Vinculado</th>
                                                    <th>Justificativa</th>
                                                    <th>Usuário</th>
                                                    <th>Data</th>
                                                </thead>
                                                <tbody>
                                                    <tr ng-repeat="manifesto in $ctrl.nfe.manifestos">
                                                        <td>{{$index+1}}</td>
                                                        <td>{{$ctrl.getDescricaoEvento(manifesto.evento)}}</td>
                                                        <td>{{manifesto.retorno}}</td>
                                                        <td>{{manifesto.vinculado ? 'Sim' : 'Não'}}</td>
                                                        <td>
                                                            <span ng-if="manifesto.justificativa">{{manifesto.justificativa}}</span>
                                                            <span style="color: #bbb; font-size: 0.8em; text-transform: uppercase; letter-spacing: 0.2em;" ng-if="!manifesto.justificativa">VAZIO</span>
                                                        </td>
                                                        <td>{{manifesto.usuario.nome || 'Automático'}}</td>
                                                        <td>{{manifesto.insertedAt | date:"dd/MM/yyyy HH:mm"}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </cbk-well>
                                </div>
                            </div>
                        </div>
                    </div>
                </loading>
            </div>
        </div>
        `
    })
